import React, { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchVendorLogin } from "../../../api/vendorDashboardLogin";
import { frontend_URL } from '../../../config/config';


const VendorDashboardEditor = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const vendor = location.state?.user;
  console.log("Received vendor from router state:", vendor);

  const { data, isLoading } = useQuery({
    queryKey: ["loginAsVendor", vendor?.email],
    queryFn: () => fetchVendorLogin(vendor.email),
    enabled: !!vendor?.email,
    refetchOnWindowFocus: false,
    retry: false,
    onError: () => {
      alert("Failed to impersonate vendor");
      navigate("/allusers");
    },
  });

  useEffect(() => {
    if (data) {
      localStorage.setItem("accessToken", data.accessToken);
      localStorage.setItem("vendorId",data.vendor._id);
      const token = data.accessToken;
      const vendorId = data.vendor._id;
      const vendorDashboardUrl = `${frontend_URL}/vendor-dashboard?token=${token}&vendorId=${vendorId}`;
      
      window.open(vendorDashboardUrl, "_blank");
    }
  }, [data, vendor]);

  return (
    <div className="p-6 font-outfit">
      <p className="text-gray-700 text-lg">
        {isLoading ? "Logging into vendor dashboard..." : "Redirecting..."}
      </p>
    </div>
  );
};

export default VendorDashboardEditor;